var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStreakMessage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_905_18983)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.482 6.82773C1.482 6.82773 2.03511 7.64031 3.19438 8.32811C3.19438 8.32811 2.35479 1.23236 7.82526 0C6.4237 5.14393 9.60807 6.5946 10.7688 3.87696C12.7073 6.46507 11.2355 8.72307 11.2355 8.72307C12.0303 8.83758 12.698 7.9692 12.698 7.9692C12.704 8.07617 12.7073 8.18388 12.7073 8.29235C12.7073 11.4446 10.1519 14 6.99967 14C3.8474 14 1.29199 11.4446 1.29199 8.29232C1.29199 7.78597 1.35827 7.29515 1.482 6.82773Z",
    fill: "#FF6536"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6984 7.9692C12.6984 7.9692 12.0307 8.83758 11.2358 8.72307C11.2358 8.72307 12.7077 6.46507 10.7692 3.87696C9.60843 6.5946 6.42406 5.14393 7.82562 0C7.53263 0.0660078 7.25788 0.148941 7 0.246586V14C10.1523 14 12.7077 11.4446 12.7077 8.29232C12.7077 8.18385 12.7043 8.07617 12.6984 7.9692Z",
    fill: "#FF421D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.49609 11.4964C4.49609 12.8788 5.6168 13.9995 6.99925 13.9995C8.3817 13.9995 9.50241 12.8788 9.50241 11.4964C9.50241 10.7564 9.18136 10.0915 8.67094 9.63322C7.70313 10.948 6.32397 8.95356 7.3988 7.49707C7.3988 7.49707 4.49609 7.86082 4.49609 11.4964Z",
    fill: "#FBBF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.50316 11.4964C9.50316 10.7564 9.18211 10.0915 8.67169 9.63322C7.70388 10.948 6.32472 8.95356 7.39955 7.49707C7.39955 7.49707 7.24183 7.51689 7 7.59321V13.9995C8.38245 13.9995 9.50316 12.8788 9.50316 11.4964Z",
    fill: "#FFA900"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_905_18983"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreakMessage);
export default __webpack_public_path__ + "static/media/streak-message.c9c136408f3461bf296c779e11c8770b.svg";
export { ForwardRef as ReactComponent };